import axiosService from 'services/axios.service';

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const restorePurchases = async (payload: any, resource: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/${resource}`, payload);
    return response?.data;
};

export const restoreAllPurchases = async (resource: any): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/${resource}`);
    return response?.data;
};
